import { useHttp } from '@veda/dashboard-ui';

const BASE = '/api/v1/pa';

function backend() {
  return window.VEDA_API_URL || process.env.REACT_APP_BACKEND_URL || '';
}

/** Restituisce il dettaglio di un invito Amministratore Ente (pubblico, no auth). */
export async function getInvitoPa(token) {
  const res = await fetch(`${backend()}${BASE}/invito/${token}`, {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) throw new Error('Invito non trovato o scaduto.');
  return res.json();
}

/** Imposta la password al primo accesso tramite invito (flusso temporaneo senza SPID). */
export async function impostaPasswordInvito(token, password, passwordConfirmation) {
  const csrf = await getCsrf();
  const res = await fetch(`${backend()}${BASE}/invito/${token}/imposta-password`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-XSRF-TOKEN': csrf },
    body: JSON.stringify({ password, password_confirmation: passwordConfirmation }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body?.message ?? Object.values(body?.errors ?? {})?.[0]?.[0] ?? 'Errore durante l\'accettazione.');
  }
  return res.json();
}

/** Restituisce il dettaglio di un invito RUP (pubblico, no auth). */
export async function getInvitoRup(token) {
  const res = await fetch(`${backend()}${BASE}/invito-rup/${token}`, {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) throw new Error('Invito non trovato o scaduto.');
  return res.json();
}

/** Imposta la password al primo accesso RUP tramite invito. */
export async function impostaPasswordInvitoRup(token, password, passwordConfirmation) {
  const csrf = await getCsrf();
  const res = await fetch(`${backend()}${BASE}/invito-rup/${token}/imposta-password`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-XSRF-TOKEN': csrf },
    body: JSON.stringify({ password, password_confirmation: passwordConfirmation }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body?.message ?? Object.values(body?.errors ?? {})?.[0]?.[0] ?? 'Errore durante l\'accettazione.');
  }
  return res.json();
}

/** @deprecated Mantenuto per compatibilità — SPID disabilitato temporaneamente */
export async function avviaSpidInvito(token) {
  const csrf = await getCsrf();
  const res = await fetch(`${backend()}${BASE}/invito/${token}/avvia-spid`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-XSRF-TOKEN': csrf },
  });
  if (!res.ok) throw new Error('Impossibile avviare il flusso SPID.');
  return res.json();
}

async function getCsrf() {
  await fetch(`${backend()}/sanctum/csrf-cookie`, { credentials: 'include' });
  return decodeURIComponent(
    document.cookie.split('; ').find((c) => c.startsWith('XSRF-TOKEN='))?.split('=')[1] ?? ''
  );
}

/** Hook per le API PA protette (amministratore_ente). */
export function usePaApi() {
  const { request, loading } = useHttp();

  const get = (url, cb = {}) => request(url, { method: 'GET', ...cb });
  const put = (url, data, cb = {}) => request(url, { method: 'PUT', body: JSON.stringify(data), ...cb });
  const post = (url, data, cb = {}) => request(url, { method: 'POST', body: JSON.stringify(data), ...cb });
  const del = (url, cb = {}) => request(url, { method: 'DELETE', ...cb });

  return {
    loading,
    getMioEnte:      (cb) => get(`${BASE}/ente`, cb),
    aggiornaMioEnte: (data, cb) => put(`${BASE}/ente`, data, cb),
    // Membri ente
    listMembri:    (cb) => get(`${BASE}/membri`, cb),
    invitaMembro:  (data, cb) => post(`${BASE}/membri/inviti`, data, cb),
    rimuoviMembro: (userId, cb) => del(`${BASE}/membri/${userId}`, cb),
    revocaInvito:  (invitoId, cb) => del(`${BASE}/membri/inviti/${invitoId}`, cb),
    // RUP associati all'ente (Multi-Tenant v3) — lato amministratore ente
    listRupAssociati:  (cb) => get(`${BASE}/rup-associati`, cb),
    invitaRup:         (data, cb) => post(`${BASE}/rup-associati`, data, cb),
    revocaRup:         (associazioneId, cb) => del(`${BASE}/rup-associati/${associazioneId}`, cb),
    // "I miei enti" — lato RUP
    listMieiEnti:      (cb) => get(`${BASE}/miei-enti`, cb),
    accettaInvitoEnte: (associazioneId, cb) => post(`${BASE}/miei-enti/${associazioneId}/accetta`, {}, cb),
  };
}
